var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 12.2734C13.2344 12.9297 12.7656 13.75 11.9922 13.75H1.98438C1.21094 13.75 0.742188 12.9297 1.11719 12.2734L6.13281 3.74219C6.50781 3.08594 7.46875 3.08594 7.86719 3.74219L12.8594 12.2734ZM6.4375 6.4375V9.4375C6.4375 9.76562 6.71875 10 7 10C7.30469 10 7.5625 9.76562 7.5625 9.4375V6.4375C7.5625 6.13281 7.30469 5.875 7 5.875C6.67188 5.875 6.4375 6.13281 6.4375 6.4375ZM7 12.25C7.39844 12.25 7.72656 11.9219 7.72656 11.5234C7.72656 11.125 7.39844 10.7969 7 10.7969C6.57812 10.7969 6.25 11.125 6.25 11.5234C6.25 11.9219 6.57812 12.25 7 12.25Z",
    fill: "#A30F28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/RedAlert.70872da0fc0cb98e351a56ba182712b5.svg";
export { ForwardRef as ReactComponent };